export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <span className="text-green-600 text-xs font-black uppercase tracking-[0.2em]">
          O que é
        </span>
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase mt-3 mb-6">
          O que é uma Máquina de Solda de Geomembrana?
        </h2>
        <div className="space-y-4 text-gray-600 text-sm md:text-base leading-relaxed">
          <p>
            A <strong className="text-gray-900">máquina de solda de geomembrana</strong> é um equipamento utilizado
            para unir, por calor, mantas de <strong className="text-gray-900">geomembrana de PEAD</strong>, PELBD, PVC e
            outros termoplásticos. A <strong className="text-gray-900">soldagem por cunha quente</strong> funde as
            superfícies internas de duas camadas sobrepostas, formando uma emenda contínua e estanque.
          </p>
          <p>
            Esse processo é essencial para a <strong className="text-gray-900">impermeabilização</strong> de aterros
            sanitários, barragens, reservatórios, canais, lagoas e tanques de aquicultura, garantindo a contenção de
            líquidos e resíduos com segurança e durabilidade.
          </p>
          <p>
            A linha SoldaGeo reúne modelos com potências de 800W a 2100W para atender desde pequenas obras até grandes
            projetos. Cada modelo é indicado para uma faixa de espessura de geomembrana e um nível de produtividade —
            conheça a diferença entre eles na <a href="#maquinas" className="text-green-600 font-bold">seção de máquinas</a> e
            no comparativo técnico abaixo.
          </p>
        </div>
      </div>
    </section>
  );
}